import { get } from './apiUtils';

const defaultUrl = '/Functions/';

export default {
  getFunctionList: () => get(defaultUrl),
};
